// The keys the open summary takes from the review (2026-10-19). While the
// sheet covers the board, the board's own keys (the step controls' arrows,
// P and L, Escape) must not move a board the reader cannot see: the sheet's
// listener, on the window in the capture phase, stops them before the step
// controls hear them, without preventing their default, so the arrows still
// scroll the sheet. Escape closes it. Pure, tested.

/** What the open summary does with a key: close the sheet, keep it from the review, or leave it alone. */
export function summaryKey(key: string, mods: { meta?: boolean; ctrl?: boolean; alt?: boolean } = {}): 'close' | 'hold' | undefined {
  if (mods.meta || mods.ctrl || mods.alt) return undefined;
  if (key === 'Escape') return 'close';
  if (key.startsWith('Arrow') || key === 'Home' || key === 'End') return 'hold';
  if (key.length === 1 && /[pl]/i.test(key)) return 'hold';
  return undefined;
}
